import React from "react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { Download, FileSpreadsheet, FileType2, ChevronDown } from "lucide-react";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/** Renders an Export button that triggers XLSX/PDF download via the /api/exports/{dataset}.{ext} endpoint. */
export default function ExportButton({ dataset, companyId }) {
  const doExport = async (ext) => {
    const token = localStorage.getItem("crm_token");
    const url = `${BACKEND_URL}/api/exports/${dataset}.${ext}${companyId ? `?company_id=${companyId}` : ""}`;
    try {
      const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) throw new Error("Export failed");
      const blob = await res.blob();
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `relay-${dataset}.${ext}`;
      document.body.appendChild(a); a.click();
      URL.revokeObjectURL(a.href); a.remove();
      toast.success(`Exported ${dataset}.${ext}`);
    } catch (e) { toast.error("Export failed"); }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="rounded-xl" data-testid={`export-${dataset}`}>
          <Download className="h-4 w-4 mr-1.5" /> Export <ChevronDown className="h-3 w-3 ml-1" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-xl">
        <DropdownMenuItem onClick={() => doExport("xlsx")} data-testid={`export-${dataset}-xlsx`}>
          <FileSpreadsheet className="h-4 w-4 mr-2 text-emerald-brand" /> Excel (.xlsx)
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => doExport("pdf")} data-testid={`export-${dataset}-pdf`}>
          <FileType2 className="h-4 w-4 mr-2 text-crimson" /> PDF
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
